module.exports = __webpack_public_path__ + "static/media/ProximaNova-BoldIt.af44a852.woff";